<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 营销模块
        </el-breadcrumb-item>
        <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="活动名称" prop="activityName">
                <el-input v-model="searchform.activityName" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <!--步骤条 填写基础信息 -->
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>活动列表</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
          >
            <el-table-column
              prop="luckydrawActivityName"
              label="活动名称"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="luckydrawRule.awardObjectTypename"
              label="奖励对象"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="activityDate" label="活动时间" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="奖励详情" min-width="60" show-overflow-tooltip>
              <!-- 表中表 -->
              <template slot-scope="scope">
                <el-popover placement="right" width="650" trigger="click">
                  <el-table :data="rulelistdata" highlight-current-row>
                    <el-table-column
                      width="120"
                      show-overflow-tooltip
                      label="活动名称"
                    >{{scope.row.luckydrawActivityName}}</el-table-column>
                    <el-table-column
                      width="140"
                      property="awardLevelName"
                      show-overflow-tooltip
                      label="奖励标题"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      show-overflow-tooltip
                      label="奖励对象"
                    >{{scope.row.luckydrawRule==null ? null:scope.row.luckydrawRule.awardObjectTypename}}</el-table-column>
                    <el-table-column
                      width="250"
                      property="awarddetail"
                      show-overflow-tooltip
                      label="奖励明细"
                    ></el-table-column>
                  </el-table>
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-search"
                    @click="getrulelistdata(scope.row)"
                  >奖励详情</el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="领取详情" min-width="60" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-search"
                  @click="getawardtable(scope.row.luckydrawRuleApplyUuid)"
                >领取详情</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="60" show-overflow-tooltip>
              <el-button type="primary" @click="search">关闭</el-button>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
      <!-- 领取详情表 -->
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>领取详情</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading2"
            element-loading-text="拼命加载中"
            :data="awardtabledate"
            style="width:100%;"
          >
            <el-table-column prop="activityName" label="活动名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outBillCode" label="出库单" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="openId" label="openid" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="瓶码" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="hidenCode" label="暗码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="awardStuffName"
              label="具体奖项"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="exchangeTime" label="领取时间" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="扫码地点" min-width="150" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange2"
            @size-change="pagesize2"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count2"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  findAwardStuffVOByConditions,
  activityfindByConditions,
  updatestate,
  findResultsByRuleApplyUUID
} from "@/api/market/marketing";
//引入导出组件模块
export default {
  name: "activitylist",
  components: {},
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      multipleSelection: [],
      activeName: "first",
      add: {
        addshow: false,
        uuids: []
      },
      listLoading: false,
      listLoading2: false,
      depart_uuid: [],
      tableData: [],
      rulelistdata: [],
      awardtabledate: [],
      packageLevellist: [
        {
          value: 1,
          label: "一级包装"
        },
        {
          value: 2,
          label: "二级包装"
        }
      ],
      //分页数据
      total_count: 1,
      currentPage: 1,
      total_count2: 1,
      //搜索表单数据
      searchform: {
        datelist: [],
        activityName: "",
        page: 1,
        pageSize: 10
      },
      searchform2: {
        luckydrawRuleApplyUuid: "",
        outBilCode: "",
        page: 1,
        pageSize: 10
      },
      // 待审核模块对象
      second: {}
    };
  },
  methods: {
    next() {
      // 步骤条
      this.show = !this.show;
      if (this.active++ >= 2) {
        this.active = 1;
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      activityfindByConditions(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].activityDate = obj[i].startDate + "~" + obj[i].stopDate;
        if (obj[i].luckydrawRule) {
          switch (Number(obj[i].luckydrawRule.awardObjectType)) {
            case 1:
              obj[i].luckydrawRule.awardObjectTypename = "消费者/一般厨师";
              break;
            case 3:
              obj[i].luckydrawRule.awardObjectTypename = "分销商";
              break;
            default:
              break;
          }
        }
      }
    },
    // 获取奖励详情
    getrulelistdata(row) {
      console.log(row);
      this.rulelistdata = row.luckydrawRuleDetailApplies;
      for (let i = 0; i < this.rulelistdata.length; i++) {
        // 拼装奖励明细字段内容
        switch (this.rulelistdata[i].awardStuffType) {
          case 0:
            this.rulelistdata[i].awardStuffTypename = "金额";
            break;
          case 1:
            this.rulelistdata[i].awardStuffTypename = "积分";
            break;
          case 2:
            this.rulelistdata[i].awardStuffTypename = "实物";
            break;
          case 3:
            this.rulelistdata[i].awardStuffTypename = "优惠卷";
            break;
          default:
            break;
        }
        switch (this.rulelistdata[i].luckydrawChanceType) {
          case 0:
            this.rulelistdata[i].luckydrawChanceTypename = "按比例";
                      this.rulelistdata[i].awarddetail =
            this.rulelistdata[i].awardStuffTypename +
            ":" +
            this.rulelistdata[i].awardStuffName +
            ";" +
            this.rulelistdata[i].luckydrawChanceTypename +
            "：" +
            (this.rulelistdata[i].luckydrawRate * 100 + "%");
            break;
          case 1:
            this.rulelistdata[i].luckydrawChanceTypename = "按箱";
                      this.rulelistdata[i].awarddetail =
            this.rulelistdata[i].awardStuffTypename +
            ":" +
            this.rulelistdata[i].awardStuffName +
            ";" +
            this.rulelistdata[i].luckydrawChanceTypename +
            "：可中奖总数：" +
            this.rulelistdata[i].luckydrawCount;
            break;
          default:
            break;
        }
      }
    },
    // 获取领取详情列表
    getawardtable(vaule) {
      this.listLoading2 = true;
      this.searchform2.luckydrawRuleApplyUuid = vaule;
      findResultsByRuleApplyUUID(this.searchform2).then(response => {
        this.awardtabledate = response.data.rows;
        this.total_count2 = response.data.total;
        this.listLoading2 = false;
      });
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.page = currPage;
      this.Tabledata(this.searchform);
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //分页跳转事件
    currentchange2(currPage) {
      this.searchform.page = currPage;
      this.getawardtable();
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize2(pageSize) {
      this.searchform.pageSize = pageSize;
      this.getawardtable();
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>